import React from "react";
import { useNavigate } from "react-router-dom";
import CustomButton from "../../../../components/customButtom/CustomButton";
const CareerPath = ({
  label1,
  label2,
  description,
  descriptionClass,
  buttonText,
}) => {
  const navigate = useNavigate();
  return (
    <div className="w-full">
      <div className="relative w-full h-[500px]">
        {/* Background Images */}
        <img
          src="/background.png"
          alt="frame overlay"
          className="absolute inset-0 w-full h-full object-cover rounded-lg"
        />

        {/* Centered Content */}
        <div className="absolute inset-0 flex flex-col items-center justify-center text-center space-y-4 px-4">
          {/* Main Text with colored section */}
          <p className="text-white text-lg md:text-5xl font-bold">
            {label1} <br />
            <span className="text-custom-pink">{label2}</span>
          </p>
          <p
            className={`text-light-gray text-sm md:text-base my-4 max-w-full ${descriptionClass}`}
          >
            {description}
          </p>
          {buttonText && (
            <CustomButton
              label={buttonText}
              onClick={() => navigate("/auth/login")}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default CareerPath;
